import { isRealNumber } from '../../../common/utils';

export const d3Indicators = {
  all: 'All Students Groups',
  black: 'African American',
  hispanic: 'Hispanic',
  white: 'White',
  nativeAmerican: 'American Indian',
  asian: 'Asian',
  pacificIslander: 'Pacific Islander',
  twoOrMoreRaces: 'Two or More Races',
  ecoDis: 'Economically Disadvantaged',
  lep: 'EL (Current & Monitored)',
  specialEdCurrent: 'Special Ed (Current)',
  specialEdFormer: 'Special Ed (Former)',
  continuouslyEnrolled: 'Continuously Enrolled',
  highFocus: 'High Focus',
};

export const additionalStudentGroupKeys = [
  'ecoDis',
  'lep',
  'specialEdCurrent',
  'specialEdFormer',
  'continuouslyEnrolled',
];

export const getFilteredIndicators = (indicators, showAdditionalStudentGroups) => {
  // If we should show all indicators, return unchanged
  if (showAdditionalStudentGroups) return indicators;

  // Otherwise, filter out additional student group keys
  return Object.fromEntries(Object.entries(indicators).filter(([key]) => !additionalStudentGroupKeys.includes(key)));
};
export const d3EmptyIndicators = Object.keys(d3Indicators).reduce((prev, curr) => {
  prev[curr] = null;
  return prev;
}, {});

export const formatNumberOrDash = (number, suffix = '', decimalPoint = 1) =>
  isRealNumber(number) ? `${parseFloat(Number(number).toFixed(decimalPoint))}${suffix}` : '-';

export const numberStringOrDash = (number) => (isRealNumber(number) ? number : number || '-');
